
                import "css-modules://src_components_title"
                export default {"Main":"_6d2e11","Large":"_fe0329","Negative":"_e86baf","Eyebrow":"_275e1d","Icon":"_a88437","Label":"_ea7998","Title":"_14aeea"}
            